/**
 * Mascaramento de dado pessoal no que sai do navegador (demanda 012 · `PRI-LGPD-04`).
 *
 * Vive **separado** do `sentry.ts` de propósito: assim dá para testá-lo sem
 * carregar o SDK, e o teste é o que prova o critério 4 da demanda — *"erro
 * provocado com telefone e CPF no payload não os expõe no evento"*.
 *
 * Mesmos padrões do `Mascara` do back, **na mesma ordem e pelo mesmo motivo**:
 * documento antes de telefone, senão um CNPJ formatado casa PELA METADE com o
 * padrão de telefone e sai como `«telefone»/0001-95` — vazamento com aparência
 * de máscara.
 */
const EMAIL = /[\w.+-]+@[\w-]+\.[\w.-]+/g
const CNPJ = /\b\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}\b/g
const CPF = /\b\d{3}\.\d{3}\.\d{3}-\d{2}\b/g
const TELEFONE = /\+?\d[\d\s().-]{9,}\d/g

export function varrer(texto: string | undefined): string {
  if (!texto) return ''

  return texto
    .replace(EMAIL, '«e-mail»')
    .replace(CNPJ, '«CNPJ»')
    .replace(CPF, '«CPF»')
    .replace(TELEFONE, '«telefone»')
}
